import styled from 'styled-components';

import PrsAlert from './PrsAlert';

// PrsAlert positioned as a top-of-card banner inside the UAM panels — bleeds
// to the panel's edges (which carry 40px padding) so the alert sits flush with
// the card frame, and reserves 24px below itself before the next content block.
//
// Variant-agnostic on purpose: callers pick variant="danger" / "success" / etc.
// the same way they would on a plain PrsAlert.
const UamBanner = styled(PrsAlert)`
  padding: 12px 40px;
  width: calc(100% + 80px);
  margin: -40px 0 24px -40px;
  box-sizing: border-box;
  border: 1px solid;
`;

export default UamBanner;
